import React from "react";
import { BadgeVariant, badgeVariantClassName } from "@toolkit/design";
import { cn } from "../../lib/utils";

type BadgeProps = React.HTMLAttributes<HTMLDivElement> & {
  variant?: BadgeVariant;
};

export const Badge: React.FC<BadgeProps> = ({
  className,
  variant = "default",
  ...props
}) => (
  <div
    className={cn(
      "inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wider transition-colors",
      badgeVariantClassName[variant],
      className,
    )}
    {...props}
  />
);
